import { useTheme } from '@material-ui/core/styles';
import { AppBar, Toolbar } from '@material-ui/core';

import useStyles from './TopNavStyles';

export default function LogoBar() {
    const theme = useTheme();
    const classes = useStyles();

    return (
        <AppBar id="logo-bar" position="relative" elevation={0} className={classes.topNav}>
            <Toolbar>
                <div className={classes.logoContainer}>
                    <img src={theme.productLogo} className={classes.productLogo} alt={theme.productName} />
                </div>
            </Toolbar>
        </AppBar>
    );
}
